import { useCallback } from 'react';
import { useStore, getSmoothStepPath, BaseEdge, useEdges, getStraightPath } from 'reactflow';
import { HANDLE_MOVE_STEP } from '@pages/schemes/constants';
import { getEdgeParams } from '@pages/schemes/utils';

const CELLS_TO_SHOW_STRAIGHT_PATH = 15;

function roundToNearestCell(num) {
    return Math.round(num / HANDLE_MOVE_STEP) * HANDLE_MOVE_STEP;
}

function getOptimalPathGetterFnFromPositions(sourcePosition, targetPosition) {
    // const OPPOSITE_POSITIONS = [[Position.Right, Position.Left], [Position.Top, Position.Bottom]];
    //
    // for (const oppositePositions of OPPOSITE_POSITIONS) {
    //   if (
    //     oppositePositions.includes(sourcePosition) &&
    //     oppositePositions.includes(targetPosition) &&
    //     sourcePosition !== targetPosition
    //   ) {
    //     return getStraightPath;
    //   }
    // }
    //
    // return getSmoothStepPath;
    return getStraightPath;
}

function FloatingEdge(props) {
    const { id, source, target } = props;
    const edges = useEdges();
    const sourceHandle = edges.find((edge) => edge.id === id).sourceHandle;

    const sourceNode = useStore(useCallback((store) => store.nodeInternals.get(source), [source]));
    const targetNode = useStore(useCallback((store) => store.nodeInternals.get(target), [target]));
    const [xGridSize, yGridSize] = useStore((store) => store.snapGrid);

    const sourceHandlesBounds = sourceNode[Symbol.for('internals')]?.handleBounds?.source;
    const currentSourceHandleBoundIndex = sourceHandlesBounds.findIndex((shb) => shb.id === sourceHandle);

    if (!sourceNode || !targetNode || currentSourceHandleBoundIndex === -1) {
        return null;
    }
    const currentSourceHandleBound = sourceHandlesBounds[currentSourceHandleBoundIndex];
    const sourceHandleBoundPosition = currentSourceHandleBound.position;

    // we don't use sx, sy, sourcePos because we don't want change source handle position
    let { tx, ty, targetPos } = getEdgeParams(sourceNode, targetNode);

    const tmpSx = sourceNode.position.x + currentSourceHandleBound.x + currentSourceHandleBound.width / 2;
    const tmpSy = sourceNode.position.y + currentSourceHandleBound.y + currentSourceHandleBound.height / 2;
    let getPath;

    // If source node is very near to target node
    if (
        Math.abs(tmpSx - tx) < CELLS_TO_SHOW_STRAIGHT_PATH * xGridSize &&
        Math.abs(tmpSy - ty) < CELLS_TO_SHOW_STRAIGHT_PATH * yGridSize
    ) {
        getPath = getOptimalPathGetterFnFromPositions(sourceHandleBoundPosition, targetPos);
    } else {
        getPath = getSmoothStepPath;
    }

    const targetX = roundToNearestCell(tx);
    const targetY = roundToNearestCell(ty);

    const [edgePath] = getPath({
        sourceX: tmpSx,
        sourceY: tmpSy,
        sourcePosition: sourceHandleBoundPosition,
        targetPosition: targetPos,
        targetX: targetX,
        targetY: targetY,
        borderRadius: 0,
    });

    return <BaseEdge path={edgePath} {...props} />;
}

export default FloatingEdge;
